import { render } from "./PsychologistNewEvaluationView.vue?vue&type=template&id=7e8d975d"
import script from "./PsychologistNewEvaluationView.vue?vue&type=script&lang=js"
export * from "./PsychologistNewEvaluationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__